import { render } from "./Product.vue?vue&type=template&id=67cc3f44"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import "./Product.vue?vue&type=style&index=0&id=67cc3f44&lang=css"
script.render = render

export default script